$(() => {
    $('body')
        .find('input[data-random-number]')
        .each((i, element) => {
            const input = $(element);

            const pattern: string = input.data('random-number-pattern').toString();
            const validatedPattern = validatePattern(pattern);
            const randomNumber = generateRandomNumber();

            input.val(insertNumberInPattern(validatedPattern, randomNumber));
        });
});

const replacementKey = '$1';

function validatePattern(pattern: string): string {
    if (!pattern) {
        return replacementKey;
    }

    if (!pattern.includes(replacementKey)) {
        return replacementKey;
    }

    return pattern;
}

function insertNumberInPattern(pattern: string, number: number): string {
    return pattern.replace(replacementKey, number.toFixed(0));
}

function generateRandomNumber(): number {
    return Math.random() * Math.pow(10, 10);
}
